module.exports = __webpack_public_path__ + "images/card-jcb.4f43a0ea5f362ffbb41c8b28cd0f7932.svg";